module.exports = __webpack_public_path__ + "images/illustrations/illustration-360-astronauts-49e53bc3f816f564eeddf5bd4d20aef7.webp";